exports = module.exports = require("../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-popup__root--1L5i6{-ms-flex-align:end;-webkit-box-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;position:fixed;z-index:99}.besidaMob-popup__overlay--36auR,.besidaMob-popup__root--1L5i6{bottom:0;left:0;right:0;top:0}.besidaMob-popup__overlay--36auR{background:rgba(0,0,0,.5);position:absolute}.besidaMob-popup__container--1Marp{-webkit-box-sizing:border-box;background:#fff;box-sizing:border-box;padding:10px;position:relative;text-align:center;width:100%}.besidaMob-popup__close--3_NoC{color:#93949c;cursor:pointer;height:10px;padding:5px;position:absolute;right:10px;top:10px;width:10px}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-popup__root--1L5i6",
	"overlay": "besidaMob-popup__overlay--36auR",
	"container": "besidaMob-popup__container--1Marp",
	"close": "besidaMob-popup__close--3_NoC"
};